import { get, post, deleteRequest } from './_defaults/fetch.js';

export const getTags = ({params, config}) => get(`/tags`, {params, ...config});
export const getTag = ({id, params, config}) => get(`/tags/${id}`, {params, ...config});
export const createTag = ({data, config}) => post('/tags', data, config);
export const updateTag = ({id, data, config}) => post(`/tags/${id}`, data, config);
export const deleteTag = ({id, config}) => deleteRequest(`/tags/${id}`, null, config);
